import {
  COMPONENT_CLASS,
  COMPONENT_NAME,
  FEATURE_CLASS,
  FEATURE_NAME,
  FEEDBACK_CLASS,
  FEEDBACK_NAME,
} from '@jusbrasil-web/shared-ga4-events'

const featureMapping: Record<string, Record<string, string | null>> = {
  [FEATURE_CLASS.COPY_CONTENT]: {
    JURISPRUDENCIA: FEATURE_NAME.COPY_JURISPRUDENCE_CONTENT,
    JURISPRUDENCE: FEATURE_NAME.COPY_JURISPRUDENCE_CONTENT,
    PECA: FEATURE_NAME.COPY_MOTION_CONTENT,
    MOTION: FEATURE_NAME.COPY_MOTION_CONTENT,
    MODELO_PECA: FEATURE_NAME.COPY_MODEL_CONTENT,
    MODEL: FEATURE_NAME.COPY_MODEL_CONTENT,
    ARTIGO: FEATURE_NAME.COPY_ARTICLE_CONTENT,
    ARTICLE: FEATURE_NAME.COPY_ARTICLE_CONTENT,
    DOUTRINA: FEATURE_NAME.COPY_DOCTRINE_CONTENT,
    DOCTRINE: FEATURE_NAME.COPY_DOCTRINE_CONTENT,
    JOURNAL: FEATURE_NAME.COPY_JOURNAL_CONTENT,
    NEWS: FEATURE_NAME.COPY_NEWS_CONTENT,
  },
  [FEATURE_CLASS.DOCUMENT_SAVE]: {
    JURISPRUDENCIA: FEATURE_NAME.JURISPRUDENCE_DOCUMENT_SAVE,
    PECA: FEATURE_NAME.MOTION_DOCUMENT_SAVE,
    MODELO_PECA: FEATURE_NAME.MODEL_DOCUMENT_SAVE,
    ARTIGO: FEATURE_NAME.ARTICLE_DOCUMENT_SAVE,
    NOTICIAS: FEATURE_NAME.NEWS_DOCUMENT_SAVE,
    DOUTRINA: FEATURE_NAME.DOCTRINE_DOCUMENT_SAVE,
    SECAO_DOUTRINA: FEATURE_NAME.DOCTRINE_DOCUMENT_SAVE,
  },
  [FEATURE_CLASS.DOCUMENT_SEARCH]: {
    JURISPRUDENCIA: FEATURE_NAME.JURISPRUDENCE_DOCUMENT_SEARCH,
    PECA: FEATURE_NAME.MOTION_DOCUMENT_SEARCH,
    MODELO_PECA: FEATURE_NAME.MODEL_DOCUMENT_SEARCH,
    ARTIGO: FEATURE_NAME.ARTICLE_DOCUMENT_SEARH,
    NOTICIAS: FEATURE_NAME.NEWS_DOCUMENT_SEARCH,
  },
}

export const mapToGA4FeatureName = (featureClass: string, artifact: string): string | null => {
  return featureMapping[featureClass]?.[artifact] || null
}

const componentMapping: Record<string, Record<string, string | null>> = {
  [COMPONENT_CLASS.RELATED_DOCUMENTS]: {
    JURISPRUDENCIA: COMPONENT_NAME.RELATED_DOCUMENTS_JURISPRUDENCE,
    JURISPRUDENCE: COMPONENT_NAME.RELATED_DOCUMENTS_JURISPRUDENCE,
    PECA: COMPONENT_NAME.RELATED_DOCUMENTS_MOTION,
    MOTION: COMPONENT_NAME.RELATED_DOCUMENTS_MOTION,
    MODELO_PECA: COMPONENT_NAME.RELATED_DOCUMENTS_MODEL,
    MODEL: COMPONENT_NAME.RELATED_DOCUMENTS_MODEL,
    ARTIGO: COMPONENT_NAME.RELATED_DOCUMENTS_ARTICLE,
    ARTICLE: COMPONENT_NAME.RELATED_DOCUMENTS_ARTICLE,
    DOUTRINA: COMPONENT_NAME.RELATED_DOCUMENTS_DOCTRINE,
    DOCTRINE: COMPONENT_NAME.RELATED_DOCUMENTS_DOCTRINE,
    DIARIOS: COMPONENT_NAME.RELATED_DOCUMENTS_JOURNAL,
    JOURNAL: COMPONENT_NAME.RELATED_DOCUMENTS_JOURNAL,
    NEWS: COMPONENT_NAME.RELATED_DOCUMENTS_NEWS,
    NOTICIAS: COMPONENT_NAME.RELATED_DOCUMENTS_NEWS,
  },
}

export const mapToGA4ComponentName = (componentClass: string, artifact: string): string | null => {
  return componentMapping[componentClass]?.[artifact] || null
}

const feedbackMapping: Record<string, Record<string, string | null>> = {
  [FEEDBACK_CLASS.COMMENT_FEEDBACK]: {
    MODELO_PECA: FEEDBACK_NAME.MODEL_COMMENT_FEEDBACK,
    ARTIGO: FEEDBACK_NAME.ARTICLE_COMMENT_FEEDBACK,
    NOTICIAS: FEEDBACK_NAME.NEWS_COMMENT_FEEDBACK,
  },
}

export const mapToGA4FeedbackName = (feedbackClass: string, artifact: string): string | null => {
  return feedbackMapping[feedbackClass]?.[artifact] || null
}
